module.exports = __webpack_public_path__ + "img/reward.c9edd7e3.png";